import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 46 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46 51\" id=\"icon-triangle\">\n  <polygon fill=\"currentColor\" fill-opacity=\".8\" fill-rule=\"evenodd\" points=\"89 67 114 112 64 112\" transform=\"rotate(90 88 24.5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol